import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";

interface OfferImportFormProps {
  onSubmit: (description: string) => Promise<void>;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export function OfferImportForm({
  onSubmit,
  onCancel,
  isSubmitting = false,
}: OfferImportFormProps) {
  const [description, setDescription] = useState("");

  const handleSubmit = async () => {
    if (description.trim() && !isSubmitting) {
      await onSubmit(description.trim());
    }
  };

  const isDisabled = !description.trim() || isSubmitting;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Import Offer</CardTitle>
      </CardHeader>
      <CardContent>
        <div>
          <Label htmlFor="offer-description">Offer Description</Label>
          <Textarea
            id="offer-description"
            placeholder="Describe the type of offer you want to create..."
            rows={6}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1"
            disabled={isSubmitting}
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={isDisabled}>
          {isSubmitting ? "Importing..." : "Import"}
        </Button>
      </CardFooter>
    </Card>
  );
}
